import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FETCH_STATS_HIGHS } from '../../../../store/js/modules/statspro/last-round-highs/actions';
import {
    lastRoundHighsRoundDataSelector,
    lastRoundHighsSeasonDataSelector
} from '../../../../store/js/modules/statspro/last-round-highs/selectors';
import { LastRoundHighsSlider } from './components/LastRoundHighsSlider';
import { getTranslation } from '../../../../../../common/react/utils/translations';
import { ToggleInput } from '../../../../../../common/react/components/ToggleInput';

const { DateTime } = luxon;

export const LastRoundHighs = ( { seasonId, compseasonId, currentRound, roundSubtitle, seasonSubtitle } ) => {
    const dispatch = useDispatch();
    const roundData = useSelector( lastRoundHighsRoundDataSelector );
    const seasonData = useSelector( lastRoundHighsSeasonDataSelector );
    const [ lastCompletedRound, setlastCompletedRound ] = useState( Number( currentRound ) );
    const [ activeSlider, setActiveSlider ] = useState( 'round' );
    const toggleActiveSlider = type => setActiveSlider( type );
    const translations = {
        lastRound: getTranslation( 'label.statspro.lastRound' ),
        round: getTranslation( 'label.statspro.round' ),
        highs: getTranslation( 'label.statspro.highs' ),
        season: getTranslation( 'label.statspro.season' )
    };

    let compSeasonData = {};

    const fetchLastRoundHighsData = ( round ) => {
        const roundsData = compSeasonData.rounds[ round - 1 ];

        if ( roundsData && ( DateTime.fromISO( roundsData.utcEndTime ) < DateTime.utc() ) ) {
            setlastCompletedRound( round );
            dispatch( FETCH_STATS_HIGHS.request( { type: 'round', id: roundsData.providerId } ) );
        } else if ( round > 1 ) {
            fetchLastRoundHighsData( round - 1 );
        }
    };

    useEffect( () => {
        fetch( `${ PULSE.app.environment.api }compseasons/${ compseasonId }` )
            .then( response => response.json() )
            .then( responseData => {
                compSeasonData = responseData.compSeasons[ 0 ];
                fetchLastRoundHighsData( lastCompletedRound );
            } );
    }, [] );

    useEffect( () => {
        if ( activeSlider === 'season' && !seasonData ) {
            dispatch( FETCH_STATS_HIGHS.request( { type: 'season', id: seasonId } ) );
        }
    }, [ activeSlider ] );

    return (
        <div className={ 'last-round-highs' }>
            <div className={ 'last-round-highs__header' }>
                <div className={ 'last-round-highs__toggle' }>
                    <span className={ 'last-round-highs__toggle-divider' }></span>
                    <ToggleInput
                        id="data-type-toggle"
                        value={ activeSlider }
                        onChange={ type => toggleActiveSlider( type ) }
                        options={ [
                            {
                                label: translations.lastRound,
                                value: 'round'
                            },
                            {
                                label: translations.season,
                                value: 'season'
                            }
                        ] }
                    />
                    <span className={ 'last-round-highs__toggle-divider' }></span>
                </div>
                <div className={ classNames( 'last-round-highs__heading-container', {
                    'is-active': activeSlider === 'round'
                } ) }>
                    <h2 className={ 'last-round-highs__title' }>{ translations.round } { lastCompletedRound } { translations.highs }</h2>
                    { roundSubtitle !== '' && (
                        <p className={ 'last-round-highs__subtitle' }>{ roundSubtitle }</p>
                    ) }
                </div>
                <div className={ classNames( 'last-round-highs__heading-container', {
                    'is-active': activeSlider === 'season'
                } ) }>
                    <h2 className={ 'last-round-highs__title' }>{ translations.season } { translations.highs }</h2>
                    { seasonSubtitle !== '' && (
                        <p className={ 'last-round-highs__subtitle' }>{ seasonSubtitle }</p>
                    ) }
                </div>
            </div>
            <div className={ classNames( 'last-round-highs__slider stats-slider fade-in-on-load', {
                'is-loaded': !!roundData,
                'is-active': activeSlider === 'round'
            } ) }>
                <LastRoundHighsSlider
                    data={ roundData }
                    type={ 'round' }
                />
            </div>
            <div className={ classNames( 'last-round-highs__slider stats-slider fade-in-on-load', {
                'is-loaded': !!seasonData,
                'is-active': activeSlider === 'season'
            } ) }>
                <LastRoundHighsSlider
                    data={ seasonData }
                    type={ 'season' }
                />
            </div>
        </div>
    );
};

LastRoundHighs.propTypes = {
    seasonId: PropTypes.string.isRequired,
    compseasonId: PropTypes.string.isRequired,
    currentRound: PropTypes.string.isRequired,
    roundSubtitle: PropTypes.string,
    seasonSubtitle: PropTypes.string
};